import {
  Female as FemaleIcon,
  HideSource as HideSourceIcon,
  Male as MaleIcon,
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { blue, pink, purple } from '@mui/material/colors';

export function GenderIcon({ gender }) {
  switch (gender?.toUpperCase()) {
    case 'M':
    case 'MALE':
      return (
        <Tooltip title="Male">
          <MaleIcon sx={{ color: blue[200], fontSize: 16 }} />
        </Tooltip>
      );
    case 'F':
    case 'FEMALE':
      return (
        <Tooltip title="Female">
          <FemaleIcon sx={{ color: pink[200], fontSize: 16 }} />
        </Tooltip>
      );
    default:
      return (
        <Tooltip title="Indeterminate">
          <HideSourceIcon sx={{ color: purple[200], fontSize: 16 }} />
        </Tooltip>
      );
  }
}
